import React, { useEffect } from "react";
import Breadcrumb from "../../components/Breadcrum/Breadcrum";
import InfoContainer from "../../components/InfoContainer";
import "./About.scss"; // Add your main CSS file for styling

// About Page Component
export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title={"About Us"}
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      />

      <InfoContainer />
      <CoreValues />
      <FounderMsg />
    </>
  );
}

const FounderMsg = () => {
  return (
    <section className="about-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-5 col-12">
            <img
              src="./assets/img/owner.avif"
              className="about-image ms-lg-auto bg-light shadow-lg img-fluid"
              alt="Gulnar Choudhary"
            />
          </div>

          <div className="col-lg-8 col-md-7 col-12">
            <div className="custom-text-block founder-msg">
              <h2 className="mb-0-about">Gulnar Choudhary</h2>

              <p className="text-muted mb-lg-4 mb-md-4">Managing Director</p>

              <p>Welcome to Dohrnii Exim Private Limited!</p>

              <p>
                At DOHRNII EXIM PRIVATE LIMITED, we’re not just about importing
                and exporting – we’re about creating connections and delivering
                quality that truly makes a difference. From chemicals and metals
                to spices and fresh produce, our goal is simple: to bring you
                the best products, wherever you are in the world.
              </p>
              <p>
                We believe in building trust and lasting relationships with
                every partner, offering not just products, but solutions that
                help your business grow. Our team is committed to providing
                reliable, high-quality goods with every shipment, every time.
              </p>

              <p className="about-thanks">
                Thank you for choosing us. We look forward to continuing our
                journey together, shaping industries and making the world a
                little better, one delivery at a time.
              </p>

              {/* <ul className="social-icon mt-4">
                <li className="social-icon-item">
                  <a
                    href="https://x.com"
                    target="_blank"
                    className="social-icon-link bi-x"
                  ></a>
                </li>

                <li className="social-icon-item">
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    className="social-icon-link bi-facebook"
                  ></a>
                </li>

                <li className="social-icon-item">
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    className="social-icon-link bi-instagram"
                  ></a>
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CoreValues = () => {
  return (
    <div className="core-values-section">
      <div className="div-block-150">
        <div className="div-block-146 values">
          <h1 className="our-custom">Our</h1>
          <h1 className="heading-88">Core Values</h1>
        </div>
        <div className="div-block-148">
          <h4 className="heading-90">Quality Over Quantity</h4>
          <p className="paragraph-47">
            We believe in providing affordable design services to businesses
            without compromising on quality. Quality over quantity!
            <br />
          </p>
        </div>
        <div className="div-block-148">
          <h4 className="heading-90">Awesome Customer Service</h4>
          <p className="paragraph-48">
            Our customers are the reason why we exist and can continue to do
            what we love. We will always strive to provide the best customer
            service and put our customers first.
            <br />
          </p>
        </div>
        <div className="div-block-148">
          <h4 className="heading-90">
            Being dependable
            <br />
          </h4>
          <p className="paragraph-49">
            Replacing a full-time designer is a big promise, and that's exactly
            what we aim for - Becoming your dependable designer that provides
            quality work on time. <br />
          </p>
        </div>
      </div>
      <div className="div-block-149"></div>
    </div>
  );
};
